import React from 'react';
import { connect } from 'formik';

import withContext from './withContext';
import { isFieldRequired } from '../../utils/yupCustom';

const SmartLabel = ({
  htmlFor,
  formik,
  formContext,
  required,
  style,
  children
}) => {
  let validationSchema =
    typeof formik.validationSchema === 'object'
      ? formik.validationSchema
      : typeof formik.validationSchema === 'function'
      ? formik.validationSchema()
      : '';

  let validationContext = null;

  if (!validationSchema && formik.validate && formContext) {
    validationSchema = formContext.yupSchema;
    validationContext = formContext.getValidationContext(formik.values);
  }

  const isRequiredField = () => {
    if (typeof required !== 'undefined') return required;
    if (!formik)
      throw new Error('Formik reference is not found! Please use formik connect on your component.');
    if (!htmlFor) return false;
    if (Object.keys(formik.values).length === 0) return false;

    //case when we use custom validation with dynamic conditions (required context object)
    if (validationContext) {
      //using formik Validation custom method with context (should implement returning of context)
      return isFieldRequired(
        validationSchema,
        htmlFor,
        formik.values,
        validationContext
      );
    } else {
      //using formik Validateion Schema (default way without Context, but with Values)
      return isFieldRequired(validationSchema, htmlFor, formik.values);
    }
  };

  
  return (
    <label
      className={isRequiredField() ? 'required-label' : ''}
      htmlFor={htmlFor}
      style={style}
    >
      {children}
    </label>
  );
};

export default React.memo(withContext(connect(SmartLabel)));
